export const USERDATAFIRM_CREATE_RESET = 'USERDATAFIRM_CREATE_RESET'
export const USERDATAFIRM_CREATE_SET_CREATED = 'USERDATAFIRM_CREATE_SET_CREATED'
export const USERDATAFIRM_CREATE_SET_ERROR = 'USERDATAFIRM_CREATE_SET_ERROR'
export const USERDATAFIRM_CREATE_SET_VIOLATIONS = 'USERDATAFIRM_CREATE_SET_VIOLATIONS'
export const USERDATAFIRM_CREATE_TOGGLE_LOADING = 'USERDATAFIRM_CREATE_TOGGLE_LOADING'
